export class Article {
  priceListItemId: number;
  isFixBaseline: boolean;
  articleName: string;
  articleDescription: string;
  articleTypeName: string;
  freePrice: number;
  freeDescription: string;
  baseline: number;
  total: number;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/Article.ts